import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class StateTaxService extends BaseService {

	constructor() {	
		super();
	}
	
	async getStateTaxRates(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/state-tax-rates' + params);		
		return data;		
	}
	
	async getStateTaxRate(id) {
		var data = await this.makeGETRequest('/api/resource/state-tax-rates/' + id);		
		return data;		
	}
	
	exportStateTaxRates(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/state-tax-rates/export' + params);		
	};	
	
	async saveStateTaxRate(rate, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/state-tax-rates/' + rate.highwayTaxRateId, rate);
		} else {
			saved = await this.makePOSTRequest('/api/resource/state-tax-rates', rate);
		}
		return saved;		
	}	
	
	async deleteStateTaxRates(ids) {
		var data = await this.makeDELETERequest('/api/resource/state-tax-rates', ids);		
		return data;		
	}
	
	//types	
	async getStateTaxTypes(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/state-tax-types' + params);		
		return data;		
	}
	
	async getStateTaxType(id) {
		var data = await this.makeGETRequest('/api/resource/state-tax-types/' + id);		
		return data;		
	}
	
	exportStateTaxType(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/state-tax-types/export' + params);		
	};	
	
	async saveStateTaxType(type, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/state-tax-types/' + type.stateTaxTypeCode, type);
		} else {
			saved = await this.makePOSTRequest('/api/resource/state-tax-types', type);
		}
		return saved;		
	}	
	
	async deleteStateTaxType(typeCode) {
		var data = await this.makeDELETERequest('/api/resource/state-tax-types/' + typeCode);		
		return data;		
	}
	
}

